export default "__VITE_ASSET__d4b7741d__"